import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialIssuesStatusesState = {};

const editIssuesSlice = createSlice({
  name: "editIssues",
  initialState: initialIssuesStatusesState,
  reducers: {
    setEditIssuesData: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setEditIssuesData } = editIssuesSlice.actions;

export const editIssues = editIssuesSlice.reducer;

export default editIssuesSlice.reducer;
